import React from 'react';
import { Link } from 'react-router-dom';
import Table from '../common/Table';
import './StandingsTable.css';

/**
 * StandingsTable component
 * Displays division standings with responsive layout
 * T065: Standings table for public viewing
 */
const StandingsTable = ({ standings }) => {
  console.log('StandingsTable received:', standings);
  
  if (!standings || standings.length === 0) {
    return (
      <div className="standings-empty">
        <p>No standings available yet.</p>
      </div>
    );
  }

  const columns = [
    { 
      header: 'Rank',
      accessor: 'rank',
      render: (standing) => (
        <span className={`rank-badge rank-${standing.rank <= 3 ? standing.rank : 'default'}`}>
          {standing.rank}
        </span>
      )
    },
    { 
      header: 'Team',
      accessor: 'teamName',
      render: (standing) => (
        <Link 
          to={`/teams/${standing.teamId}`}
          className="team-link"
        >
          {standing.teamName || 'Unknown Team'}
        </Link>
      )
    },
    { header: 'Played', accessor: 'matchesPlayed' },
    { header: 'Won', accessor: 'matchesWon' },
    { header: 'Lost', accessor: 'matchesLost' },
    { header: 'Games W', accessor: 'gamesWon' },
    { header: 'Games L', accessor: 'gamesLost' },
    { header: 'Points', accessor: 'points' },
    { 
      header: 'Win %',
      accessor: 'winPercentage',
      render: (standing) => formatWinPercentage(standing.winPercentage)
    },
  ];

  const formatWinPercentage = (percentage) => {
    if (typeof percentage === 'string') {
      return `${percentage}%`;
    }
    return percentage ? `${Number(percentage).toFixed(1)}%` : '0.0%';
  };

  return (
    <div className="standings-table">
      <Table columns={columns} data={standings} />
    </div>
  );
};

export default StandingsTable;
